import template from './template';
import script from './script';

export default function() {
    template();
    script();
};
